package pwgs.ui.scenes.allowedversionsscene

import kotlinx.serialization.Serializable
import visage.ds.forms.FieldModel
import visage.rmi.VisageController

@VisageController(AllowedVersionsSceneProps::class, AllowedVersionsSceneModel::class)
interface AllowedVersions {
    fun load()
    fun addVersion()
    fun deleteVersion(ver: String)
}

@Serializable
class AllowedVersionsSceneProps(val projectId: Long)

@Serializable
class AllowedVersionsSceneModel(val versions: List<String>) {
    var isLoading = true
    var addDialogModel: AllowedVersionsSceneAddVersionDialogModel? = null
}

@Serializable
class AllowedVersionsSceneAddVersionDialogModel {
    var isLoading = false
    var error: String? = null
    val versionFieldModel = FieldModel("")
}